import { Box, Grid, Hidden, Link, makeStyles, Typography } from "@material-ui/core";
import {
  DiscordIcon,
  GithubIcon,
  LinkedinIcon,
  MediumIcon,
  RedditIcon,
  TelegramIcon,
  TwitterIcon,
  YoutubeIcon,
} from "../Icon";

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    padding: "3rem 0rem 1rem 0rem",
    [theme.breakpoints.down("xs")]: {
      padding: "3rem 0rem 5rem 0rem",
    },
  },
  rootGrid: {
    padding: "0rem 1.5rem 0rem 1.5rem",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  colorfulLink: {
    color: "#1C8CF3",
    fontSize: "14px",
    fontWeight: 400,
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
  footerLeft: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      marginTop: "0.5rem",
    },
  },
  normalText: {
    fontSize: "14px",
    fontWeight: 400,
    color: theme.palette.text.hint,
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
  footerRight: {
    display: "flex",
    justifyContent: "end",
    [theme.breakpoints.between(900, 1400)]: {
      paddingRight: "3rem",
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center !important",
    },
  },
  icon: {
    color: "#7E8FA3",
    "&:hover": {
      color: "#1C8CF3",
    },
  },
}));

export default function Footer() {
  const cls = useStyle();

  const TextFooter = () => (
    <Grid item xs={12} md={6} className={cls.footerLeft}>
      <Typography className={cls.normalText}>COPYRIGHT © {new Date().getFullYear()}&nbsp;</Typography>
      <Link target="_blank" href="https://trava.finance/" className={cls.colorfulLink}>
        Trava.Finance.
      </Link>
      <Typography className={cls.normalText}>&nbsp;All right reserved</Typography>
    </Grid>
  );

  return (
    <Box className={cls.root}>
      <Grid container className={cls.rootGrid}>
        <Hidden smDown>
          <TextFooter />
        </Hidden>
        <Grid item xs={12} md={6} container>
          <Grid item xs={12} className={cls.footerRight}>
            <Link target="_blank" href="https://twitter.com/trava_finance" style={{ marginRight: "1rem" }}>
              <TwitterIcon size="24px" className={cls.icon} />
            </Link>
            <Link target="_blank" href="https://t.me/trava_finance" style={{ marginRight: "1rem" }}>
              <TelegramIcon size="24px" className={cls.icon} />
            </Link>
            <Link target="_blank" href="https://www.reddit.com/r/TravaFinance/" style={{ marginRight: "1rem" }}>
              <RedditIcon size="24px" className={cls.icon} />
            </Link>
            <Link target="_blank" href="https://medium.com/@travafinance">
              <MediumIcon size="24px" className={cls.icon} />
            </Link>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "0.5rem" }} className={cls.footerRight}>
            <Link target="_blank" href="https://discord.gg/nYthYcHB9K" style={{ marginRight: "1rem" }}>
              <DiscordIcon size="24px" className={cls.icon} />
            </Link>
            <Link target="_blank" href="https://github.com/TravaFinance" style={{ marginRight: "1rem" }}>
              <GithubIcon size="24px" className={cls.icon} />
            </Link>
            <Link
              target="_blank"
              href="https://www.youtube.com/channel/UCm7cOf7adwrFaEe8zKwdg8A"
              style={{ marginRight: "1rem" }}
            >
              <YoutubeIcon size="24px" className={cls.icon} />
            </Link>
            <Link target="_blank" href="https://www.linkedin.com/company/trava-finance">
              <LinkedinIcon size="24px" className={cls.icon} />
            </Link>
          </Grid>
        </Grid>
        <Hidden mdUp>
          <TextFooter />
        </Hidden>
      </Grid>
    </Box>
  );
}
